import * as S from './styles';

export function NotificationStripe(): JSX.Element {
  return (
    <S.Wrapper>
      <S.Stripe />
    </S.Wrapper>
  );
}
